import { captureException } from 'helpers/raven'
import { getDeviceInfo } from 'helpers/useragent'
import {
  IsAndroidInterfaceAvailable,
  IsIOSInterfaceAvailable,
  IsWebviewInterfaceAvailable,
  UpdateAndroidWebviewHeader,
  UpdateIOSWebviewHeader,
  UpdateWebviewHeaderLogo
} from './header.types'

const isIOSInterfaceAvailable: IsIOSInterfaceAvailable = (sender) => (
  typeof global.webkit !== 'undefined' &&
  typeof global.webkit.messageHandlers !== 'undefined' &&
  typeof global.webkit.messageHandlers[sender] !== 'undefined' &&
  typeof global.webkit.messageHandlers[sender].postMessage === 'function'
)

const isAndroidInterfaceAvailable: IsAndroidInterfaceAvailable = (sender) => (
  typeof global.Android !== 'undefined' &&
  typeof global.Android[sender] !== 'undefined' &&
  typeof global.Android[sender] === 'function'
)

export const isWebviewInterfaceAvailable: IsWebviewInterfaceAvailable = (sender) => (
  isIOSInterfaceAvailable(sender) || isAndroidInterfaceAvailable(sender)
)

const updateAndroidWebviewHeader: UpdateAndroidWebviewHeader = ({
  args = {},
  sender
}) => {
  if (isAndroidInterfaceAvailable(sender)) {
    try {
      global.Android[sender]?.call?.(
        global.Android,
        args?.brandLogo
      )
    } catch (error) {
      captureException(new Error('Unable to update header logo'), {
        extra: { error },
        level: 'warning'
      })
    }
  }
}

const updateIOSWebviewHeader: UpdateIOSWebviewHeader = ({
  args = {},
  sender
}) => {
  if (isIOSInterfaceAvailable(sender)) {
    global.webkit.messageHandlers[sender].postMessage(args)
  }
}

export const updateWebviewHeaderLogo: UpdateWebviewHeaderLogo = ({
  args = {}
}) => {
  const userAgent = getDeviceInfo()

  if (userAgent.webviewAndroid) {
    updateAndroidWebviewHeader({ args, sender: 'updateHeader' })
  } else if (userAgent.webviewIOS) {
    updateIOSWebviewHeader({ args, sender: 'updateHeader' })
  }
}
